import { createSlice } from "@reduxjs/toolkit";

interface FavoriteInitialStateModel {
  filter:any;
}
const FavoriteInitialState: FavoriteInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    SortProperty:"InsertDate",
    SortType:"asc"
  }
};

const favoriteSlice = createSlice({
  name: "FavoriteSlice ",
  initialState: FavoriteInitialState,
  reducers: {
    handleSetFavoriteFilter: (state, action) => {
      state.filter = action.payload.data;
    },
    handleResetFavoriteFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc"
      };
    },
   
   
    
  },
});

export const {
  handleSetFavoriteFilter,
  handleResetFavoriteFitler,
} = favoriteSlice.actions;
export default favoriteSlice;
